"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var resOrderBy = function resOrderBy(ob, alter) {
  return alter || ob;
};

var buildResult = function buildResult(ob, cb) {
  return ob ? cb(ob) : {};
};

var buildData = function buildData(dir) {
  return function (ob) {
    return {
      sort: "".concat(dir === 'desc' ? '-' : '').concat(ob)
    };
  };
};

var joinOrderMlkl = function joinOrderMlkl() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      alternative = _ref.alternative,
      orderBy = _ref.orderBy,
      orderDirection = _ref.orderDirection;

  return function (params) {
    return (0, _extends2.default)({}, params || {}, {}, buildResult(resOrderBy(orderBy, alternative), buildData(orderDirection)));
  };
};

var _default = joinOrderMlkl;
exports.default = _default;